import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { checkAvailability, createCharacter } from 'actions/registration';
import { fetchUser } from 'actions/user';

import Loading from 'components/Loading';

import CreateCharacterComponent from './CreateCharacterComponent';
import CharacterNameContext from './CharacterNameContext';
import ConfirmCancelCreateModal from './components/ConfirmCancelCreateModal';

export class CreateCharacterContainer extends Component {
  static displayName = 'CreateCharacterContainer';

  mounted = false;

  state = {
    avatar: undefined,
    gender: undefined,
    errors: {},
    isFetching: false,
    isConfirmCancelModalOpen: false,
    isSubmitting: false,
    userName: '',
    userNameIsAvailable: false,
  };

  componentDidMount = async () => {
    const { dispatch } = this.props;
    // We're mounted
    this.mounted = true;
    // Fetch the user state
    this.setState({ isFetching: true });
    const { user: { name: userName } } = await dispatch(fetchUser());
    this.setState({ userName, isFetching: false }, () => {
      // Validate the user name after setting state
      this.handleBlurName();
    });
  };

  handleBlurName = async () => {
    const { dispatch } = this.props;
    const { userName } = this.state;
    this.setState(state => ({
      isCheckingAvailability: true,
      userNameIsAvailable: false,
      errors: {
        ...state.errors,
        userName: undefined,
      },
    }));
    try {
      const { isSuccess } = await dispatch(checkAvailability(userName));
      this.setState(state => ({
        isCheckingAvailability: false,
        userNameIsAvailable: isSuccess,
        errors: {
          ...state.errors,
          userName: isSuccess ? undefined : `'${userName}' is taken.`,
        },
      }));
    } catch (e) {
      // TODO: handle actual errors
    }
  };

  handleChangeName = (e) => {
    this.setState({
      userName: e.target.value,
      userNameIsAvailable: false,
    });
  };

  handleChangeGender = (gender) => {
    this.setState({ gender });
  };

  handleCloseCancelModal = () => {
    this.setState({ isConfirmCancelModalOpen: false });
  };

  handleRequestCancel = () => {
    this.setState({ isConfirmCancelModalOpen: true });
  };

  handleSelectAvatar = (avatar) => {
    this.setState({ avatar });
  };

  handleSubmit = async () => {
    const { dispatch, history } = this.props;
    const { avatar, gender, userName } = this.state;
    this.setState({ isSubmitting: true });
    // Send to the character-creation endpoint
    const data = await dispatch(createCharacter({ avatar, gender, userName }));
    const { isSuccess } = data;
    if (isSuccess) {
      history.push('/');
    }
  };

  render = () => {
    const {
      avatar,
      errors,
      isCheckingAvailability,
      isConfirmCancelModalOpen,
      isFetching,
      isSubmitting,
      gender,
      userName,
      userNameIsAvailable,
    } = this.state;

    if (isFetching) {
      return (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'absolute',
            height: '100vh',
            width: '100vw',
            top: '0',
            left: '0',
          }}
        >
          <Loading spinner />
        </div>
      );
    }

    const canSubmit = !!(
      avatar !== undefined
      && gender !== undefined
      && userName.length
      && userNameIsAvailable
    );

    return (
      <CharacterNameContext.Provider
        value={{
          isCheckingAvailability,
          isAvailable: userNameIsAvailable,
          error: errors.userName,
          onBlur: this.handleBlurName,
          onChange: this.handleChangeName,
          value: userName,
        }}
      >
        <Fragment>
          <CreateCharacterComponent
            avatar={avatar}
            canSubmit={canSubmit}
            errors={errors}
            gender={gender}
            isSubmitting={isSubmitting}
            onChangeGender={this.handleChangeGender}
            onChangeName={this.handleChangeName}
            onRequestCancel={this.handleRequestCancel}
            onSelectAvatar={this.handleSelectAvatar}
            onSubmit={this.handleSubmit}
            userName={userName}
          />
          <ConfirmCancelCreateModal
            isOpen={isConfirmCancelModalOpen}
            onRequestClose={this.handleCloseCancelModal}
          />
        </Fragment>
      </CharacterNameContext.Provider>
    );
  }
}

const mapStateToProps = ({ user }) => ({ user });

export default withRouter(connect(mapStateToProps)(CreateCharacterContainer));